import React from 'react'
import { MiniCard, Register, Card } from './styles.style'
import Link from 'react-router-dom/Link'

import { connect } from 'react-redux'
import { Creators as SiteCreators } from '../../../../ducks/site/site'
import { bindActionCreators } from 'redux'
import { routes } from '../../../../constants/routes.constants'

class PopupCard extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			isOpen: false,
			status: 'bloquear',
			canUpdateStatus: true
		}
	}
	render() {
		const { logged, setMenuOptionPath } = this.props
		const { ENTRAR, MUVICARD_CADASTRO } = routes
		return (
			<MiniCard>
				<Card>
					<Register className="register">
						{logged ? (
							<a
								href={`${MUVICARD_CADASTRO}`}
								title="Realizar cadastro do nosso cartão">
								Fazer meu <br /> cartão muvicard
							</a>
						) : (
							<Link
								to={`${ENTRAR}`}
								className="about"
								title="Fazer meu cartão muvicard">
								<span
									onClick={() => {
										setMenuOptionPath(`${MUVICARD_CADASTRO}`)
									}}>
									Fazer meu <br /> cartão muvicard{' '}
								</span>
							</Link>
						)}
					</Register>
				</Card>
			</MiniCard>
		)
	}
}

const mapStateToProps = ({ site }) => ({
	menuOptionPath: site.menuOptionPath
})

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			setMenuOptionPath: SiteCreators.menuOptionPath
		},
		dispatch
	)

export default connect(mapStateToProps, mapDispatchToProps)(PopupCard)
